namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_entity_form_view, {

		Period_field: {
			Content: {
				padding: 0,
			},
		},

		Social_media_field: {
			Content: {
				flex: {
					direction: 'column',
				},
			},
		},

		Mass_media_field: {
			Content: {
				flex: {
					direction: 'column',
				},
			},
		},

		Query_group: {
			'$mol_form_field': {
				flex: {
					basis: '25rem',
				},
			},
		},

		Group: {
			'$mol_form_field': {
				flex: {
					basis: '10rem',
				},
			},
		},

		Files: {
			'$mol_form_field': {
				flex: {
					basis: '6rem',
				},
			},
		},

		Tags_group: {
			'$mol_form_field': {
				flex: {
					basis: '10rem',
				},
			},
		},
		
		Type: {
			Clear: {
				position: 'absolute',
				right: 0,
			},
		},

	} )
	
}
